import { env } from '@/src/config/env'

export const getLegacyUrl = (url: string, lang = 'fr') => {
  let legacyUrl = env.EXPO_PUBLIC_LEGACY_BASE_URL
  let cleanedUrl = url

  if (url.startsWith('/')) {
    cleanedUrl = url.slice(1)
  }

  if (env.NODE_ENV === 'test' && !env.EXPO_PUBLIC_LEGACY_BASE_URL) {
    //env files are not loaded in jest environment
    //https://github.com/expo/expo/issues/26513
    //https://github.com/expo/expo/pull/26766
    legacyUrl = 'https://preprod.hozana.org'
  }

  if (lang === 'fr') {
    return `${env.EXPO_PUBLIC_LEGACY_BASE_URL ?? legacyUrl}/${cleanedUrl}`
  }
  return `${env.EXPO_PUBLIC_LEGACY_BASE_URL ?? legacyUrl}/${lang}${cleanedUrl ? `/${cleanedUrl}` : ''}`
}
